<template>
  <label :for="id" class="relative block h-9 sm:h-11 cursor-pointer">
    <input
      :id="id"
      :checked="value"
      class="sr-only"
      type="checkbox"
      @change="$emit('input', $event.target.checked)"
    />
    <div class="relative h-full flex items-center border rounded-full z-20">
      <div :class="{ 'font-semibold': value }" class="w-1/2 text-center pl-2">
        {{ labels[0] }}
      </div>
      <div :class="{ 'font-semibold': !value }" class="w-1/2 text-center pr-2">
        {{ labels[1] }}
      </div>
    </div>
    <div
      :style="{
        width: 'calc(50% + 0.5rem)',
        transform: value ? 'translateX(0)' : 'translateX(calc(100% - 1rem))',
      }"
      class="absolute left-0 inset-y-0 w-1/2 bg-grey border rounded-full z-10 transform transition-transform duration-200"
    />
  </label>
</template>

<script>
export default {
  name: "Toggle",
  props: {
    id: {
      type: String,
      required: true,
    },
    value: {
      type: Boolean,
    },
    labels: {
      type: Array,
      required: true,
    },
  },
};
</script>
